function Filter() {
  return function(value, currencyCode = 'USD', languageCode = 'en') {

    const formatter = new Intl.NumberFormat(languageCode, {
      style: 'currency',
      currency: currencyCode
    });

    return formatter.format(value);
  };
}

Filter.$inject = [];

export default Filter;



// WEBPACK FOOTER //
// ./src/filters/venueCurrencyFilter.js